export enum DataType {
  String = 0,
  Number = 1,
  Currency = 2,
  Date = 3,
  Link = 4,
  Status = 5
}

export interface TableColumn {
  name: string;
  key: string;
  type: DataType;
  link?: string;
}

export interface DataFilter {
  [key: string]: string;
}



// WEBPACK FOOTER //
// ./src/app/models/table.ts